export const util = {
  methods: {
    generateID (prefix, number = 2) {
      let array = new Uint32Array(number)
      window.crypto.getRandomValues(array)
      let str = ''
      for (let i = 0; i < array.length; i++) {
        str += (i < 2 || i > 5 ? '' : '-') + array[i].toString(16).slice(-4)
      }
      return prefix + str
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js